import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Plus, X } from "lucide-react";
import { getProducts } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

const HOTSPOTS = [
  { id: "savon-noir-eucalyptus", top: "60%", left: "24%" },
  { id: "ghassoul-brut", top: "42%", left: "52%" },
  { id: "eau-de-rose-pure", top: "55%", left: "78%" },
];

const fmt = (n) => "€" + Number(n).toFixed(2).replace(".", ",");

export default function Lookbook() {
  const { t } = useLang();
  const [map, setMap] = useState({});
  const [open, setOpen] = useState(null);

  useEffect(() => {
    getProducts()
      .then((list) => {
        const m = {};
        list.forEach((p) => { m[p.id] = p; });
        setMap(m);
      })
      .catch(() => {});
  }, []);

  return (
    <section className="products-section lookbook reveal" aria-label="Lookbook Rituel Hammam" data-testid="lookbook-section">
      <div className="lookbook__head">
        <p className="section-tag">{t("home.lookbookTag")}</p>
        <h2 className="section-title">{t("home.lookbookTitle")}</h2>
        <p className="section-body">{t("home.lookbookDesc")}</p>
      </div>

      <div className="lookbook__wrap img-curtain">
        <img className="lookbook__img" src="/images/site-hammam.png" alt="Rituel Hammam — savon noir, ghassoul et eau de rose" />
        {HOTSPOTS.map((h) => {
          const p = map[h.id];
          if (!p) return null;
          const isOpen = open === h.id;
          return (
            <React.Fragment key={h.id}>
              <button
                className={`hotspot ${isOpen ? "open" : ""}`}
                style={{ top: h.top, left: h.left }}
                onClick={() => setOpen(isOpen ? null : h.id)}
                aria-label={`Découvrir ${p.name}`}
                data-testid={`hotspot-${h.id}`}
              >
                {isOpen ? <X size={16} /> : <Plus size={16} />}
              </button>
              {isOpen ? (
                <div className="hotspot-card" style={{ top: h.top, left: h.left }} data-testid={`hotspot-card-${h.id}`}>
                  <img src={p.image} alt={p.name} />
                  <div className="hc-name">{p.name}</div>
                  <div className="hc-price">{fmt(p.effective_price != null ? p.effective_price : p.price)}</div>
                  <Link to={`/products/${p.id}`} className="hc-link" data-testid={`hotspot-link-${h.id}`}>
                    {t("common.viewDetail")}
                  </Link>
                </div>
              ) : null}
            </React.Fragment>
          );
        })}
      </div>
    </section>
  );
}
